import dynamic from "next/dynamic";

export const DynamicLayoutWidget035 = dynamic(
  () => import("./LayoutWidget035"),
  {
    suspense: true,
  }
);
